"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ToInteger = ToInteger;
exports.defaultCompareFunction = defaultCompareFunction;
function ToInteger(num) {
    if (typeof num !== "number") num = Number(num);
    if (Number.isNaN(num)) num = 0;
    return Math.trunc(num);
}

function isPlusZero(val) {
    return val === 0 && 1 / val === Infinity;
}

function defaultCompareFunction(x, y) {
    var _ref = [Number.isNaN(x), Number.isNaN(y)];
    const isNaN_x = _ref[0],
          isNaN_y = _ref[1];


    if (isNaN_x && isNaN_y) return 0;

    if (isNaN_x) return 1;

    if (isNaN_y) return -1;

    if (x < y) return -1;

    if (x > y) return 1;

    if (x === 0 && y === 0) {
        var _ref2 = [isPlusZero(x), isPlusZero(y)];
        const isPlusZero_x = _ref2[0],
              isPlusZero_y = _ref2[1];


        if (!isPlusZero_x && isPlusZero_y) return -1;

        if (isPlusZero_x && !isPlusZero_y) return 1;
    }

    return 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@petamoriken/float16/lib/spec.js
// module id = 57
// module chunks = 0